import React from 'react';

import {
    StartIcon,
    SuppressionsIcon,
    TemplatesIcon,
    StatisticsIcon,
    SettingsIcon,
    LogsIcon,
    ExportsIcon,
    ContactsIcon,
    VerificationsIcon,
} from '@dev/ee-components';
import { AccessLevel } from '@dev/ee-api/ee-api-models';
import { LogsPaths, StatisticsPaths, VerificationPaths } from '../../dictionaries/paths';
import { FormsPaths, LandingPagePaths, ContactsPaths, TemplatesPaths } from '@api/dashboards/Marketing/paths';
import { capitalizeString } from '@dev/ee-tools';
import { useTranslation } from 'react-i18next';
interface RouteConfType {
    label: string;
    icon?: JSX.Element;
    url?: string;
    hideOnMobile?: boolean;
    /**
     * if route is in fact a route with param, but we want to get menu item displayed as activated no mather what param is the default one
     */
    memberOf?: string[];
    accessLevel?: AccessLevel[];
    subMenuItems?: Omit<RouteConfType, 'subMenuItems'>[];
}

export const useMenuItems = (): Array<RouteConfType> => {
    const { t } = useTranslation();

    return [
        {
            label: capitalizeString(t('start')),
            icon: <StartIcon />,
            url: '/',
            accessLevel: [AccessLevel.ViewAccount],
        },
        {
            label: capitalizeString(t('activity')),
            icon: <StatisticsIcon />,
            url: StatisticsPaths.StatisticsOverview,
            accessLevel: [AccessLevel.ViewReports],
        },
        {
            label: capitalizeString(t('logs')),
            icon: <LogsIcon />,
            url: LogsPaths.LogsEmail,
            memberOf: ['/logs'],
            accessLevel: [AccessLevel.ViewReports],
        },
        {
            label: capitalizeString(t('suppressions')),
            icon: <SuppressionsIcon />,
            url: '/suppressions',
            accessLevel: [AccessLevel.ViewSuppressions],
        },
        {
            label: capitalizeString(t('templates')),
            icon: <TemplatesIcon />,
            url: TemplatesPaths?.TemplateList || 'templates/new',
            memberOf: ['/legacy/#/templates'],
            accessLevel: [AccessLevel.ViewTemplates],
        },
        {
            label: capitalizeString(t('audience')),
            icon: <ContactsIcon />,
            accessLevel: [AccessLevel.ViewContacts, AccessLevel.ViewForms, AccessLevel.ViewLandingPages],
            subMenuItems: [
                {
                    label: capitalizeString(t('contacts')),
                    url: ContactsPaths.ContactsOverview,
                    memberOf: ['/contacts'],
                    accessLevel: [AccessLevel.ViewContacts],
                },
                {
                    label: capitalizeString(t('forms')),
                    url: FormsPaths.FormList,
                    memberOf: ['/legacy/#/forms'],
                    accessLevel: [AccessLevel.ViewForms],
                },
                {
                    label: capitalizeString(t('landingpages')),
                    url: LandingPagePaths.LandingPageList,
                    memberOf: ['/legacy/#/landingpages'],
                    accessLevel: [AccessLevel.ViewLandingPages],
                },
            ],
        },
        {
            label: t('verifications'),
            icon: <VerificationsIcon />,
            url: VerificationPaths.VerificationsTabs,
            accessLevel: [AccessLevel.VerifyEmails],
        },
        {
            label: t('exports'),
            icon: <ExportsIcon />,
            url: '/exports',
            accessLevel: [AccessLevel.Export],
        },
        {
            label: capitalizeString(t('settings')),
            icon: <SettingsIcon />,
            url: '/settings',
            accessLevel: [AccessLevel.ViewSettings],
        },
    ];
};

export { RouteConfType };
